import React, { useEffect, useState } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { SelectContent, SelectItem, SelectValue, SelectTrigger, Select } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { useFieldArray } from 'react-hook-form';
import convertToRoman from '@/src/helpers/convertToRoman';
import { useSelector } from 'react-redux';
function DomesticPaxForm({ form, plainSearchForm, index }) {
  const { fields, append } = useFieldArray({ control: form.control, name: `ticket.${index}.passenger` });
  const { ReservationRS } = useSelector(state => state.flights.holdedFlightResponse);
  var [passengers, setPassengers] = useState([]);
  const totalPaxTypes = () => {
    var paxs = [];
    var pnrNumber = '';
    var plasmaBook = ReservationRS.filter(rs => rs.Supplier == 2);
    if (plasmaBook.length > 0) {
      pnrNumber = plasmaBook[0].Reservations[0].PNRNo;
    }
    var adultPax = [];
    var childPax = [];
    for (let index = 1; index <= plainSearchForm.noOfPassenger; index++) {
      adultPax.push({ Name: "ADULT", Number: index, PNRNo: pnrNumber });
    }
    for (let index = 1; index <= plainSearchForm.child; index++) {
      childPax.push({ Name: "CHILD", Number: index, PNRNo: pnrNumber });
    }
    var yetiReservation = ReservationRS.filter(rs => rs.Supplier == 1);
    if (yetiReservation.length > 0) {
      let chdCount = 0;
      let ADTCount = 0;
      yetiReservation[0].Reservations.forEach((reservation, i) => {
        if (reservation.PaxType === 'CHD')
          reservation.PaxType = "CHILD";
        if (reservation.PaxType === 'ADULT') {
          adultPax[ADTCount].PNRNo = reservation.PNRNo;
          ADTCount++;

        } else {
          childPax[chdCount].PNRNo = reservation.PNRNo;
          chdCount++;
        }
      });
    };
    paxs = adultPax.concat(childPax);
    setPassengers(paxs);
    return paxs;
  }


  useEffect(() => {
    var totalPaxs = totalPaxTypes();
    totalPaxs.map(paxs =>
      append({
        "Title": "",
        "FirstName": "",
        "MiddleName": "",
        "LastName": "",
        "PaxType": paxs.Name,
        "Gender": "",
        "Nationality": "NP",
        "PaxRemarks": "",
        "isContactPerson": false,
        "PassengerID": paxs.PNRNo,
      })
    )
  }, []);
  const FuncContactChange = (fld, e) => {
    var name = fld.name.split(".isContactPerson")[0];
    var currPaxInfo = form.getValues(name);
    form.setValue("ticket.0.ContactPerson", currPaxInfo);
  }
  return (
    <>
      {passengers && passengers.length > 0 && passengers.map((paxField, i) => {
        return (<Card className="shadow-none">
          <CardHeader className="pt-0">
            <CardTitle className="text-lg">

              Passenger - {convertToRoman(i + 1)} ({paxField.Name})
            </CardTitle>
            <CardDescription>
              Fill up the passenger detail matching your government document.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 justify-between">
              <FormField
                control={form.control}
                name={`ticket.${index}.passenger.${i}.Title`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Title</FormLabel>
                    <Select
                      onValueChange={field.onChange}
                      defaultValue={field.value}
                    >
                      <FormControl>
                        <SelectTrigger>
                          <SelectValue placeholder="Select Title" />
                        </SelectTrigger>
                      </FormControl>
                      <SelectContent>
                        <SelectItem value="Mr">Mr</SelectItem>
                        <SelectItem value="Miss">Miss</SelectItem>
                        <SelectItem value="Mrs">Mrs</SelectItem>
                      </SelectContent>
                    </Select>
                    {/* <FormDescription>
You can manage email addresses in your{" "}
<Link href="/examples/forms">email settings</Link>.
</FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name={`ticket.${index}.passenger.${i}.FirstName`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>First Name</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name={`ticket.${index}.passenger.${i}.LastName`}

                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Last Name</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name={`ticket.${index}.passenger.${i}.Gender`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Gender</FormLabel>
                    <Select
                      onValueChange={field.onChange}
                      defaultValue={field.value}
                    >
                      <FormControl>
                        <SelectTrigger>
                          <SelectValue placeholder="Select Gender" />
                        </SelectTrigger>
                      </FormControl>
                      <SelectContent>
                        <SelectItem value="M">Male</SelectItem>
                        <SelectItem value="F">Female</SelectItem>
                        <SelectItem value="O">Others</SelectItem>
                      </SelectContent>
                    </Select>
                    {/* <FormDescription>
You can manage email addresses in your{" "}
<Link href="/examples/forms">email settings</Link>.
</FormDescription> */}
                    <FormMessage />
                  </FormItem>

                )}
              />
              <FormField
                control={form.control}
                name={`ticket.${index}.passenger.${i}.Nationality`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Nationality</FormLabel>
                    <Select
                      onValueChange={field.onChange}
                      defaultValue={field.value}
                    >
                      <FormControl>
                        <SelectTrigger>
                          <SelectValue placeholder="Select Gender" />
                        </SelectTrigger>
                      </FormControl>
                      <SelectContent>
                        <SelectItem value="NP">Nepali</SelectItem>
                        <SelectItem value="IN">Indian</SelectItem>
                      </SelectContent>
                    </Select>
                    {/* <FormDescription>
You can manage email addresses in your{" "}
<Link href="/examples/forms">email settings</Link>.
</FormDescription> */}
                    <FormMessage />
                  </FormItem>

                )}
              />
              <FormField
                control={form.control}
                name={`ticket.${index}.passenger.${i}.isContactPerson`}

                render={({ field }) => (
                  <FormItem className="flex mt-5">
                    <FormControl>
                      <div className="flex items-center space-x-2">
                        <Checkbox
                          id={"contactPerson" + "index" + index + "px" + i}
                          checked={field.value}
                          onCheckedChange={(e) => {
                            field.onChange(e);
                            FuncContactChange(field, e);
                          }}
                        />
                        <label
                          htmlFor={"contactPerson" + "index" + index + "px" + i}
                          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                          I'm Contact Person
                        </label>
                      </div>
                    </FormControl>

                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
          </CardContent>
        </Card>)
      })}

      <Card className="shadow-none">
        <CardHeader className="pt-0">
          <CardTitle className="text-lg">
            Contact Information
          </CardTitle>
          <CardDescription>
            Fill up the person detail to whom airline can contact for any .
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 justify-between">
            <FormField
              control={form.control}
              name={`ticket.${index}.ContactPerson.Title`}
              render={({ field }) => (
                <FormItem className="flex flex-col">
                  <FormLabel>Title</FormLabel>
                  <Select
                    onValueChange={field.onChange}
                    defaultValue={field.value}
                  >
                    <FormControl>
                      <SelectTrigger>
                        <SelectValue placeholder="Select Title" />
                      </SelectTrigger>
                    </FormControl>
                    <SelectContent>
                      <SelectItem value="Mr">Mr</SelectItem>
                      <SelectItem value="Miss">Miss</SelectItem>
                      <SelectItem value="Mrs">Mrs</SelectItem>
                    </SelectContent>
                  </Select>
                  {/* <FormDescription>
You can manage email addresses in your{" "}
<Link href="/examples/forms">email settings</Link>.
</FormDescription> */}
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={`ticket.${index}.ContactPerson.FirstName`}
              render={({ field }) => (
                <FormItem className="flex flex-col">
                  <FormLabel>First Name</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={`ticket.${index}.ContactPerson.LastName`}
              render={({ field }) => (
                <FormItem className="flex flex-col">
                  <FormLabel>Last Name</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={`ticket.${index}.ContactPerson.Email`}
              render={({ field }) => (
                <FormItem className="flex flex-col">
                  <FormLabel>Email</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={`ticket.${index}.ContactPerson.ContactNo`}
              render={({ field }) => (
                <FormItem className="flex flex-col">
                  <FormLabel>Contact No</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={`ticket.${index}.ContactPerson.Nationality`}
              render={({ field }) => (
                <FormItem className="flex flex-col">
                  <FormLabel>Nationality</FormLabel>
                  <Select
                    onValueChange={field.onChange}
                    defaultValue={field.value}
                  >
                    <FormControl>
                      <SelectTrigger>
                        <SelectValue placeholder="Select Gender" />
                      </SelectTrigger>
                    </FormControl>
                    <SelectContent>
                      <SelectItem value="NP">Nepali</SelectItem>
                      <SelectItem value="IN">Indian</SelectItem>
                    </SelectContent>
                  </Select>
                  {/* <FormDescription>
You can manage email addresses in your{" "}
<Link href="/examples/forms">email settings</Link>.
</FormDescription> */}
                  <FormMessage />
                </FormItem>

              )}
            />
          </div>
        </CardContent>
      </Card>
    </>
  )
}

export default DomesticPaxForm
